import { action } from 'typesafe-actions';
import {
  OrganisationUserActionTypes,
  AddUserRequest, // request originating from ui
  DeleteUserRequest
} from 'types';

export const fetchOrganisationUsersStart = (id: string) =>
  action(OrganisationUserActionTypes.FETCH_USERS_BY_ORG_ID_START, {
    organisationId: id
  });

export const fetchOrganisationUsersSuccess = (users: any) =>
  action(OrganisationUserActionTypes.FETCH_USERS_BY_ORG_ID_SUCCESS, users);

export const fetchOrganisationUsersFailure = (error: any) =>
  action(
    OrganisationUserActionTypes.FETCH_USERS_BY_ORG_ID_FAILURE,
    null,
    null,
    error
  );

export const addOrganisationUserStart = (addUserRequest: AddUserRequest) =>
  action(OrganisationUserActionTypes.ADD_USERS_TO_ORG_START, addUserRequest);

export const addOrganisationUserSuccess = () =>
  action(OrganisationUserActionTypes.ADD_USERS_TO_ORG_SUCCESS);

export const addOrganisationUserFailure = (error: any) =>
  action(
    OrganisationUserActionTypes.ADD_USERS_TO_ORG_FAILURE,
    null,
    null,
    error
  );

export const setAdminUserModelOpenStart = (open: boolean) =>
  action(OrganisationUserActionTypes.OPEN_ADD_ADMINISTRATOR_MODAL_START, open);

export const deleteUserStart = (deleteUserRequest: DeleteUserRequest) =>
  action(
    OrganisationUserActionTypes.DELETE_USERS_TO_ORG_START,
    deleteUserRequest
  );

export const deleteUserSuccess = () =>
  action(OrganisationUserActionTypes.DELETE_USERS_TO_ORG_SUCCESS, null);

export const deleteUserFailure = (error: any) =>
  action(
    OrganisationUserActionTypes.DELETE_USERS_TO_ORG_FAILURE,
    null,
    null,
    error
  );

export const removeErrors = () =>
  action(OrganisationUserActionTypes.REMOVE_ERROR);

export const resetUserAdded = () =>
  action(OrganisationUserActionTypes.RESET_USER_ADDED_FLAG);

export const resetUserDeleted = () =>
  action(OrganisationUserActionTypes.RESET_USER_DELETED_FLAG);
